import React, { ReactNode } from 'react';

import cx from 'classnames';
import { isEmpty } from 'ramda';

import { EVENT_OPTION_CONFIG } from 'components/Pages/Admin/Itinerary/Details/DetailsChronologicalMode/Event/config';

import { FontAwesomeIcon } from '../../../../../../components/shared/Icon/FontAwesome';
import { IEventsProps } from '../types';
import s from './index.module.css';

export const Events = ({ tripEvent, isFlightTable, timeFormat }: IEventsProps) => {
  const { getContent, getLabel } = EVENT_OPTION_CONFIG[tripEvent.type];
  const isAlternate = 'isAlternate' in tripEvent.data! && tripEvent.data.isAlternate;

  return (
    <div className={s.content}>
      <div className={cx(s.icon, isFlightTable && s.hideIcon)}>
        <FontAwesomeIcon className={tripEvent.icon} />
      </div>
      <EventContent
        content={getContent(tripEvent, { readonly: true, timeFormat })}
        label={getLabel(tripEvent, { readonly: true, timeFormat })}
        isAlternate={isAlternate}
      />
    </div>
  );
};

export const EventContent = ({
  content,
  label,
  isAlternate,
  className,
  labelClassName,
}: {
  content: ReactNode;
  label: ReactNode;
  isAlternate?: boolean;
  className?: string;
  labelClassName?: string;
}) => {
  const showLabel = !isEmpty(label);

  return (
    <div className={cx(s.eventDetails, isAlternate && s.alternate, className)}>
      {showLabel &&
        (Array.isArray(label) ? (
          <div className={s.labels}>{label}</div>
        ) : (
          <div className={labelClassName}>{label}</div>
        ))}
      {content}
    </div>
  );
};
